import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/Poshmark-Titles';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Crash Course on Crafting Captivating Poshmark Titles</title>
        <meta
          name='description'
          content="In this article, we'll show you the anatomy of a great listing title, plus more tips to help you create winning titles every time."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-titles' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-titles' />
        <meta property='og:title' content='A Crash Course on Crafting Captivating Poshmark Titles' />
        <meta
          property='og:description'
          content="In this article, we'll show you the anatomy of a great listing title, plus more tips to help you create winning titles every time."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
